export const DTS_SOCKET_DATA= 'DTS_SOCKET_DATA';
export const DAS_SOCKET_DATA = 'DAS_SOCKET_DATA';

export const SAND_INGRSS_GRAPH_CONFIG = 'SAND_INGRSS_GRAPH_CONFIG';
